export class CPFUtil {
    static BLACKLIST: Array<string> = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
        '12345678909'
    ]

    static STRICT_STRIP_REGEX: RegExp = /[.-]/g
    static LOOSE_STRIP_REGEX: RegExp = /[^\d]/g

    static verifierDigit = (digits: string): number => {
        const numbers: Array<number> = digits.split('').map((number) => {
            return parseInt(number, 10)
        })

        const modulus: number = numbers.length + 1
        const multiplied: Array<number> = numbers.map((number, index) => number * (modulus - index))
        const mod: number = multiplied.reduce((buffer, number) => buffer + number) % 11

        return mod < 2 ? 0 : 11 - mod
    }

    static strip = (number: string, strict?: boolean): string => {
        const regex: RegExp = strict ? CPFUtil.STRICT_STRIP_REGEX : CPFUtil.LOOSE_STRIP_REGEX
        return (number || '').replace(regex, '')
    }

    static format = (number: string): string => {
        return this.strip(number).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4')
    }

    static isValid = (number: string, strict?: boolean): boolean => {
        const stripped: string = this.strip(number, strict)

        // CPF must be defined
        if (!stripped) {
            return false
        }

        // CPF must have 11 chars
        if (stripped.length !== 11) {
            return false
        }

        // CPF can't be blacklisted
        if (CPFUtil.BLACKLIST.includes(stripped)) {
            return false
        }

        let numbers: string = stripped.substr(0, 9)
        numbers += this.verifierDigit(numbers)
        numbers += this.verifierDigit(numbers)

        return numbers.substr(-2) === stripped.substr(-2)
    }

    static generate = (formatted?: boolean): string => {
        let numbers: string = ''

        for (let i = 0; i < 9; i += 1) {
            numbers += Math.floor(Math.random() * 9)
        }

        numbers += this.verifierDigit(numbers)
        numbers += this.verifierDigit(numbers)

        return formatted ? this.format(numbers) : numbers
    }

    static clean = (cpf: string) => parseInt(cpf.replace(/\D/g, ''))

    /**
     * Limpa um CNPJ mantendo apenas os caracteres válidos ([0-9A-Z]) e
     * normalizando para maiúsculas. Preserva letras do CNPJ alfanumérico
     * (IN RFB 2229/2024) e zeros à esquerda — retorna sempre string.
     * Usa uma classe negada ([^0-9A-Za-z]) em vez de listar a máscara para
     * ser robusto a entradas inesperadas (ex.: emojis, unicode acidental).
     */
    static cleanCnpj = (cnpj: string): string => (cnpj || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase()
}

export default CPFUtil
